import { Routes } from '@angular/router';
import { authGuard, noAuthGuard } from './guards/auth.guard';

export const APP_ROUTES: Routes = [
  {
    path: '',
    loadChildren: () => import('./tabs/tabs.routes').then(m => m.TABS_ROUTES),
    canActivate: [authGuard],
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.routes').then(m => m.AUTH_ROUTES),
    canActivate: [noAuthGuard],
  },
  {
    path: 'unauthorized',
    loadChildren: () => import('./unauthorized/unauthorized.routes').then(m => m.UNAUTHORIZED_ROUTES),
  },
];
